export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7135.364a091d.jpg";